export function getAdminErrorMessage(error, fallback = "Kayıt başarısız. Alanları kontrol edin.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return fallback;
}
